export function genResourceHubPages<T>(allItems: Array<T>, itemsPerPage = 9): Array<T>[] {
  const res: Array<T>[] = [];

  for (let i = 0; i < (allItems?.length ?? 0) / itemsPerPage; i += 1) {
    const newPage: Array<T> = allItems?.slice(0 + i * itemsPerPage, i * itemsPerPage + itemsPerPage) ?? [];
    if (newPage.length > 0) res.push(newPage);
  }

  return res;
}
